module.exports = __webpack_public_path__ + "img/Trade (Active).6d96bce0.svg";